import Box from '@mui/material/Box';

export default function PrivacyPolicyPage() {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    width: '90%',
                    maxWidth: '800px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                }}
            >
                <h1>Privacy Policy for Zipzy</h1>

                <p>
                    <strong>Last updated:</strong> December 08, 2025
                </p>

                <p>
                    This Privacy Policy describes Our policies and procedures on the collection, use
                    and disclosure of Your information when You use the Service and tells You about
                    Your privacy rights and how the law protects You.
                </p>

                <p>
                    We use Your Personal Data to provide and improve the Service. By using the
                    Service, You agree to the collection and use of information in accordance with
                    this Privacy Policy.
                </p>

                <h2>Interpretation and Definitions</h2>

                <h3>Interpretation</h3>
                <p>
                    The words whose initial letters are capitalized have meanings defined under the
                    following conditions. The following definitions shall have the same meaning
                    regardless of whether they appear in singular or in plural.
                </p>

                <h3>Definitions</h3>
                <ul>
                    <li>
                        <strong>Account</strong> means a unique account created for You to access
                        our Service.
                    </li>
                    <li>
                        <strong>Affiliate</strong> means an entity that controls, is controlled by,
                        or is under common control with a party.
                    </li>
                    <li>
                        <strong>Application</strong> refers to Zipzy, the software program provided
                        by the Company.
                    </li>
                    <li>
                        <strong>Company</strong> refers to Zipzy Mobility Private Limited,
                        Bengaluru, Karnataka, India.
                    </li>
                    <li>
                        <strong>Country</strong> refers to: Karnataka, India.
                    </li>
                    <li>
                        <strong>Device</strong> means any device that can access the Service.
                    </li>
                    <li>
                        <strong>Personal Data</strong> is any information that relates to an
                        identified or identifiable individual.
                    </li>
                    <li>
                        <strong>Service</strong> refers to the Application.
                    </li>
                    <li>
                        <strong>Service Provider</strong> means any third party that processes data
                        on behalf of the Company.
                    </li>
                    <li>
                        <strong>Usage Data</strong> refers to data collected automatically when
                        using the Service.
                    </li>
                    <li>
                        <strong>You</strong> means the individual using the Service.
                    </li>
                </ul>

                <h2>Collecting and Using Your Personal Data</h2>

                <h3>Types of Data Collected</h3>

                <h4>Personal Data</h4>
                <ul>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                    <li>Address, State, ZIP/Postal code, City</li>
                    <li>Usage Data</li>
                </ul>

                <h4>Usage Data</h4>
                <p>
                    Usage Data is collected automatically and may include IP address, browser type,
                    device identifiers, operating system, and diagnostic data.
                </p>

                <h3>Information Collected while Using the Application</h3>
                <ul>
                    <li>Location data (with your permission)</li>
                </ul>

                <p>
                    You can enable or disable access to this information at any time through your
                    device settings.
                </p>

                <h2>Use of Your Personal Data</h2>

                <ul>
                    <li>To provide and maintain the Service</li>
                    <li>To manage Your Account</li>
                    <li>For the performance of a contract</li>
                    <li>To contact You</li>
                    <li>To provide news and promotional offers</li>
                    <li>To manage Your requests</li>
                    <li>For business transfers</li>
                    <li>For data analysis and service improvement</li>
                </ul>

                <h2>Payments and In-App Purchases</h2>

                <p>
                    The Application may offer in-app purchases for certain features or services. All
                    payments are processed securely through Razorpay.
                </p>

                <p>
                    Razorpay may collect and process your payment information in accordance with its
                    own Privacy Policy. We do not store your complete card or banking details on our
                    servers.
                </p>

                <p>
                    You can review Razorpay’s Privacy Policy here:
                    <a
                        href="https://razorpay.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://razorpay.com/privacy
                    </a>
                </p>

                <h2>Sharing of Your Personal Data</h2>

                <ul>
                    <li>With Service Providers</li>
                    <li>For business transfers</li>
                    <li>With Affiliates</li>
                    <li>With business partners</li>
                    <li>With other users (public areas)</li>
                    <li>With Your consent</li>
                </ul>

                <h2>Retention of Your Personal Data</h2>
                <p>
                    We retain Personal Data only as long as necessary to fulfill the purposes
                    outlined in this Privacy Policy.
                </p>

                <h2>Transfer of Your Personal Data</h2>
                <p>
                    Your data may be transferred and processed outside your jurisdiction. By using
                    the Service, you consent to this transfer.
                </p>

                <h2>Delete Your Personal Data</h2>
                <p>
                    You may delete or request deletion of your Personal Data at any time through
                    your account or by contacting us.
                </p>

                <h2>Disclosure of Your Personal Data</h2>

                <h3>Business Transactions</h3>
                <p>
                    If the Company is involved in a merger or asset sale, your data may be
                    transferred.
                </p>

                <h3>Law Enforcement</h3>
                <p>We may disclose your data if required by law.</p>

                <h3>Other Legal Requirements</h3>
                <ul>
                    <li>To comply with legal obligations</li>
                    <li>To protect Company rights</li>
                    <li>To prevent wrongdoing</li>
                    <li>To protect users and public safety</li>
                </ul>

                <h2>Security of Your Personal Data</h2>
                <p>
                    We use commercially reasonable methods to protect your data, but no transmission
                    is 100% secure.
                </p>

                <h2>Children's Privacy</h2>
                <p>
                    Our Service does not address anyone under the age of 13. We do not knowingly
                    collect data from children.
                </p>

                <h2>Links to Other Websites</h2>
                <p>We are not responsible for the privacy practices of third-party websites.</p>

                <h2>Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Changes will be posted on
                    this page.
                </p>

                <h2>Contact Us</h2>

                <ul>
                    <li>Email: admin@zipzyride.com</li>
                    <li>
                        Website:{' '}
                        <a href="https://zipzyride.com/contact-us">
                            https://zipzyride.com/contact-us
                        </a>
                    </li>
                    <li>Phone: +91 8826373484</li>
                    <li>
                        Mailing Address: FLAT NO 303 BLOCK A, RENAISSANCE PARK 3, Bengaluru North,
                        Bengaluru, Karnataka, India, 560055
                    </li>
                </ul>

                <br />
                <br />
                <br />
                <br />
                <br />
            </Box>
        </Box>
    );
}
